import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { NGOCard } from "@/components/NGOCard";

export default function StoryDetail() {
  const { slug } = useParams();
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/stories/${slug}`).then((r) => setStory(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="min-h-[60vh] flex items-center justify-center text-stone-500">Loading…</div>;
  if (!story) return <div className="min-h-[60vh] flex items-center justify-center text-stone-500">Story not found.</div>;

  return (
    <article>
      <div className="relative h-72 md:h-96">
        <img src={story.hero_image} alt={story.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-brand/90 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 max-w-3xl mx-auto px-4 pb-8">
          <Link to="/stories" className="inline-flex items-center gap-1 text-stone-200 text-sm mb-3 hover:text-white"><ArrowLeft size={15} /> All stories</Link>
          <span className="block text-xs font-semibold uppercase tracking-wide text-terracotta-border">{story.district}</span>
          <h1 className="text-2xl md:text-4xl font-extrabold text-white mt-2">{story.title}</h1>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-10">
        <p className="text-lg text-stone-700 font-medium measure mb-6">{story.standfirst}</p>
        <div className="prose prose-stone measure text-stone-700 leading-relaxed whitespace-pre-line">{story.body}</div>

        {story.orgs?.length > 0 && (
          <div className="mt-12">
            <h2 className="text-xl font-bold text-slate-brand mb-4">The organisation behind this</h2>
            <div className="grid sm:grid-cols-2 gap-6">
              {story.orgs.map((o) => <NGOCard key={o.id} org={{ ...o, state: "Tamil Nadu" }} />)}
            </div>
          </div>
        )}
      </div>
    </article>
  );
}
